export class FixedRemunerationExpenseModel {
  tractorPlanningMaintenance: number = 0;
  insuranceAndLicensing: number = 0;
  totalFixedRemunerationExpense: number = 0;
}
